import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonListCardComponent } from './skeleton-list-card.component';
import { HmfSkeletonComponent } from '@dsg-tech/homefield-angular';

@NgModule({
  declarations: [SkeletonListCardComponent],
  imports: [
    CommonModule,
    HmfSkeletonComponent
  ],
  exports: [SkeletonListCardComponent]
})
export class SkeletonListCardModule { }
